import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperationsDashboard from "./OperationsDashboard";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function OperationsDashboardPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
             sx={{
               display: {
                 xs: "block",
                 sm: "block",
                 md: "none",
               },
             }}
           >
             <AppHeader />
           </MDBox>
      <OperationsDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default OperationsDashboardPage;
